import { Component, Input } from '@angular/core';
import { ComingSoonComponent } from '../../../../shared/components/coming-soon/coming-soon.component';
import { AssetVersionPipe } from '../../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-copilot-wizard-tile',
  imports: [ComingSoonComponent, AssetVersionPipe],
  templateUrl: './copilot-wizard-tile.component.html',
  styleUrl: './copilot-wizard-tile.component.scss'
})
export class CopilotWizardTileComponent {
  @Input() isExpiredUser: boolean = false;
  @Input() iconPath: string = '';
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() isComingSoon: boolean = false;
  isHovered: boolean = false;
}
